<template>
  <div>
    <b-form @submit="onSubmit" v-if="sendStatus == 'init'">
      <form-contact :contact.sync="contact" />
      <div class="form__group field">
        <input type="input" class="form__field" placeholder="Betreff" name="subject" id="subject" v-model="subject"
          required />
        <label for="subject" class="form__label">Betreff *</label>
      </div>
      <div class="form__group field">
        <textarea cols="" rows="7" class="form__field" placeholder="Nachricht" name="body" v-model="body" id='body'
          required></textarea>
        <label for="body" class="form__label">Nachricht *</label>
      </div>

      <form-cc-me :ccme.sync="ccme" />

      <privacy-policy :ppAccepted.sync="ppAccepted" :pnUrl="pnUrl" />

      <div class="form__group field text-right">
        <input type="submit" class="btn btn-outline-primary" value="Absenden" :disabled="!ppAccepted" />
      </div>
    </b-form>
    
    <b-alert show v-else-if="sendStatus == 'pending'">
      <div>
        <i class="fa fa-spin fa-spinner" />
        Wird gesendet
      </div>
    </b-alert>
    <b-alert show variant="success" v-else-if="sendStatus == 'success' && !('error' in response)">
      <div>
        <i class="fa fa-warning" />
        {{ response.data.message }}
      </div>
    </b-alert>
    <b-alert show variant="danger" v-else-if="'error' in response">
      <div>
        <i class="fa fa-warning" />
        {{ response.error.message }}
      </div>
    </b-alert>
    <b-alert show variant="danger" v-else>
      <div>
        <i class="fa fa-warning" />
        Fehler beim Senden
      </div>
    </b-alert>
  </div>
</template>


<script>
import FormContact from "./FormContact.vue";
import FormCcMe from "./FormCcMe.vue";
import PrivacyPolicy from "./PrivacyPolicy.vue"

export default {
  props: ["apiUrl", "privacyNoticeUrl"],
  data() {
    return {
      contact: {},
      ccme: false,
      ppAccepted: false, // Did the user has accepted the conditions of the privacy policy
      pnUrl: this.privacyNoticeUrl,
      body: "Sehr geehrtes fumiX-Team,\n\n",
      subject:"",
      sendStatus: "init",
      response: {}
    };
  },
  methods: {
    onSubmit(evt) {
      this.sendStatus = "pending";
      evt.preventDefault();
      $.ajax({
        method: "POST",
        url: this.apiUrl,
        data: Object.assign(
          {
            action: "send"
          },
          this.contact,
          {
            subject: this.subject,
            body: this.body,
            ccme: this.ccme
          }
        ),
        complete: (req, status) => {
          this.sendStatus = status;
          this.response = JSON.parse(req.responseText);
        }
      });
      this.$el.scrollIntoView();
    }
  },
  components: {
    FormContact,
    FormCcMe,
    PrivacyPolicy
  }
};
</script>

<style>
.alert-vue {
  font-weight: bold;
}
</style>